<template>
  <v-flex>
    <div class="mb-6">
      <v-btn to="/deal/create" color="orange">新增</v-btn>
    </div>

    <v-data-table :headers="thead" :items="deals" disable-pagination hide-default-footer>
      <template v-slot:item.no="{ item }">
        <span class="blue--text">{{ item.no }}</span>
      </template>

      <template v-slot:item.available="{ item }">
        <template v-if="item.available">
          <v-icon color="green" class="mr-3">mdi-checkbox-blank-circle</v-icon>啟用
        </template>
        <template v-else>
          <v-icon color="blue-grey lighten-3" class="mr-3">mdi-checkbox-blank-circle-outline</v-icon>停用
        </template>
      </template>

      <template v-slot:item.deal_id="{ item }">
        <v-btn :to="`/deal/${item.deal_id}`" outlined color="blue">檢視/修改</v-btn>
      </template>
    </v-data-table>
  </v-flex>
</template>



<script>
import { mapState, mapActions } from "vuex";

import dealApi from "@/api/deal";

export default {
  components: {},

  mixins: [],

  props: [],
  data() {
    return {
      deals: [],

      thead: [
        {
          text: "",
          value: "no",
          align: "center"
        },
        {
          text: "方案名稱",
          value: "display_name"
        },
        {
          text: "點數",
          value: "quantity",
          align: "right"
        },
        {
          text: "金額",
          value: "price",
          align: "right"
        },
        {
          text: "啟用狀態",
          value: "available"
        },
        {
          text: "",
          value: "deal_id"
        }
      ]
    };
  },

  computed: {},
  watch: {},
  methods: {},

  mounted() {
    dealApi
      .getAll()
      .then(res => {
        this.deals = res.deals;

        this.deals.forEach((item, idx) => {
          item.no = idx + 1;
        });
      })
      .catch(err => {});
  }
};
</script>

<style lang="scss" scoped>
</style>
